import workspaceQuery from 'graphql/queries/salesLedger/SalesVatOnlyWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesVatOnlyQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesVatOnlyDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesVatOnlyMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/salesLedger/SaveSalesVatOnlyTempMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesVatOnlyFragment.graphql';

import { formActions } from 'actions/salesLedger/SalesVatOnlyAction';

const SalesVatOnly = {
  type: 'SalesVatOnly',
  title: 'Vat Only Invoice/Credit',
  formTitle: 'Vat Only Invoice/Credit',
  formUrl: '/Customers/VatOnly/Details/',
  workspaceUrl: '/Customers/VatOnly/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'SALES_LEDGER_VAT_ONLY',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default SalesVatOnly;
